import Image from 'next/image';
import { Section } from '../section/section.comp';
import { StyledDiv } from './banner.styles';

import multiplePlatforms from '../../../public/assets/crossplatform-feature-dark.png';

export const Banner = () => {
	return (
		<Section>
			<StyledDiv>
				<div className="text-wrapper">
					<h3>Common Ninja Search Engine</h3>
					<p>
						The Common Ninja Search Engine platform helps website builders find
						the best site widgets, apps, plugins, tools, add-ons, and
						extensions! Compatible with all major website building platforms -
						big or small - and updated regularly, our Search Engine tool
						provides you with the business tools your site needs!
					</p>
				</div>
				<Image
					src={multiplePlatforms}
					alt="Multiple platforms"
					width={685}
					height={400}
				/>
			</StyledDiv>
		</Section>
	);
};
